import { stringParam } from '@blockit/web-shared/router/searchCodec';
import { CustomDomainTestPage } from '@features/custom-domain/components/CustomDomainTestPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const CustomDomainTestSearchSchema = z.object({ address: stringParam, token: stringParam });

export const Route = createFileRoute('/custom-domain-test')({
  validateSearch: CustomDomainTestSearchSchema,
  component: CustomDomainTestPage,
});
